import { render, staticRenderFns } from "./ShippedModal.vue?vue&type=template&id=469d798c&"
import script from "./ShippedModal.vue?vue&type=script&lang=js&"
export * from "./ShippedModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports